import { store } from '../redux/store';
import type { Company } from '../types/company';

interface GetUsersResponse {
  users: Company[];
}

export const companyService = {
  async getUsers(userType: string = 'snapmenu', role: string = 'superadmin'): Promise<GetUsersResponse> {
    // Get companyBaseUrl from Redux store
    const { companyBaseUrl } = store.getState().auth;
    const url = `${companyBaseUrl}/getUsers?sandboxdocs=true&user_type=${userType}&role=${role}&_t=${Date.now()}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(errorData || `HTTP error! status: ${response.status}`);
    }

    const result: GetUsersResponse = await response.json();
    return result;
  },
};
